<template>
  <div :class="heightFlag == true ? 'manHeight' : 'zujian'">
    <div id="map">
    <div class="detail">
      <div class="searchBox" ref="searchBox">
        <el-form :inline="true" :model="searchFrom" ref="searchFrom"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
          <el-form-item label="时间区间:" prop="time">
            {{mapData.actualLoadingTime|dateFormat}}-{{mapData.actualUnloadingTime|dateFormat}}
          </el-form-item>
          <el-form-item label="车牌号码:" prop="vchNo">
            {{searchFrom.vchNo}}
          </el-form-item>
        </el-form>
      </div>
      <div v-if="gpsInfos.length>0">
        <div class="box1">
          <div class="item"><span class="name">行驶时间：</span><span>{{runTime}}</span></div>
          <div class="item"><span class="name">行驶里程：</span><span>{{mapData.kilometres}}</span></div>
        </div>
        <div class="box2">
          <div class="name item" @click="reduceSudu" style="cursor: pointer;">减速播放</div>
          <div class="btn1 item" @click="pauseAnimation"> <i class="fa fa-pause-circle"></i></div>
          <div class="btn1 item" @click="startAnimation"> <i class="fa fa-play-circle" style="color: #e62323"></i></div>
          <!-- <div class="btn1 item" @click="clearFn"> <i class="fa fa-stop-circle"></i></div> -->
          <div class="name item" @click="addSudu" style="cursor: pointer;">加速播放</div>
        </div>
      </div>
      <div v-else style="text-align: center;">暂无轨迹</div>

    </div>
    <div class="table" v-if="isDetail">
      <div class="close" @click="closeFn"><i class="el-icon-close"></i></div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="车辆" name="gps">
            <el-table :data="gpsInfos"  ref="vehList"  width="100%" height="260px" v-loading="loading" >
              <el-table-column  type="index"  width="55" label="序号"></el-table-column>
            <el-table-column property=""  width="120" label="车牌号" >
                <template>
                  {{searchFrom.vchNo}}
                </template>
              </el-table-column>
              <!-- :formatter="dateFormat" -->
              <el-table-column prop="gPSDate" width="170"   label="上报时间"></el-table-column>
              <el-table-column prop="addressGrid"  min-width="260" :show-overflow-tooltip="true" label="当前位置"></el-table-column>
              <el-table-column  prop="speed" width="140" label="当前速度(KM/H)" ></el-table-column>
              <el-table-column  prop="direction" width="140" :formatter="fx" label="当前方向" ></el-table-column>
              <el-table-column  prop="encryptLongitude" width="200" :show-overflow-tooltip="true" label="经度" ></el-table-column>
              <el-table-column  prop="encryptDimension" width="200" :show-overflow-tooltip="true" label="纬度" ></el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane label="司机" name="siji"  v-if="mapData.type == 1||mapData.type == 3">
            <el-table :data="lineArr1"  ref="vehList"  width="100%" height="260px" v-loading="loadingDrive"  >
              <el-table-column  type="index"  width="55" label="序号"></el-table-column>
            <el-table-column property=""  width="120" label="司机姓名" >
                <template>
                  {{mapData.dirverName}}
                </template>
              </el-table-column>
              <el-table-column prop="gpsDate" width="170" label="上报时间" :formatter="dateTimeFormat"></el-table-column>
              <el-table-column prop="addressGrid" min-width="530"  :show-overflow-tooltip="true" label="当前位置"></el-table-column>
              <el-table-column  prop="encryptLongitude" width="200" :show-overflow-tooltip="true" label="经度" ></el-table-column>
              <el-table-column  prop="encryptDimension" width="200" :show-overflow-tooltip="true" label="纬度" ></el-table-column>
            </el-table>
        </el-tab-pane>
      </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from 'AMap'
import { vhcHisList, zjVhcHisList, driverHisDataList, changeCarLog } from '@/api/vehMonitor'
import { dateTimeFormat } from '@/utils/util'
export default {
  name: 'maphistory',
  props: {
    mapData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    heightFlag: {
      type: Boolean,
      default: function () {
      }
    }
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      searchFrom: {
        serverName: '中物货运互联智慧物流平台'
      },
      marker: null,
      marker1: null,
      map: null,
      polyline: null,
      polyline1: null,
      isPlay: false,
      lineArr: [],
      mapAdress: '',
      lineArr1: [],
      gpsInfos: [],
      driInfos: [],
      isDetail: false,
      activeName: 'gps',
      changeCar: 'xian',
      changeLog: [],
      dirverGPS: [],
      loadingDrive: false,
      runTime: 0,
      mileage: 0

    }
  },
  created () {

  },
  mounted () {
    this.initMap()
    console.log(this.mapData, 'hhh')
    this.mapData.vhcNo = this.mapData.plateNumber
    this.mapData.vhcNoColor = this.mapData.licensePlateColor
    this.searchFn()
  },
  methods: {
    searchFn () {
      this.clearFn()
      this.searchFrom.startTime = this.dateFormat(this.mapData.actualLoadingTime)
      this.searchFrom.endTime = this.dateFormat(this.mapData.actualUnloadingTime)
      this.searchFrom.wayNo = this.mapData.wayNo
      this.searchFrom.vchNo = this.mapData.vhcNo
      this.searchFrom.driverId = this.mapData.dirverId
      let vhcNoColor = this.mapData.vhcNoColor == 93 ? 3 : this.mapData.vhcNoColor
      this.searchFrom.vco = vhcNoColor
      this.searchFrom.serverName = '中物货运互联智慧物流平台'
      this.loading = true
      vhcHisList(this.searchFrom).then(res => {
        if (res) {
          this.lineArr = res.list
          if (this.lineArr.length > 0) {
            this.polylineFn()
          }
          if (res.flag == 'hbase') {
            this.loading = false
            if (res.gpsInfos.length == 0) {
              zjVhcHisList(this.searchFrom).then(res1 => {
                this.gpsInfos = res1.gpsInfos
                this.runTime = res1.runTime
                this.loading = false
                this.isDetail = true
              })
            } else {
              this.gpsInfos = res.gpsInfos
              this.runTime = res.runTime
              this.isDetail = true
            }
          } else {
            zjVhcHisList(this.searchFrom).then(res1 => {
              this.gpsInfos = res1.gpsInfos
              if (res1.gpsInfos.length > 0) {
                this.$nextTick(() => {
                  let selection = this.gpsInfos
                  this.$set(this, 'mileage', (selection[selection.length - 1].mileage - selection[0].mileage))
                  const start = new Date(selection[0].gPSDate).getTime()
                  const end = new Date(selection[selection.length - 1].gPSDate).getTime()
                  this.runTime = this.TimeCha(start, end)
                  this.biaodianFn(res1.gpsInfos)
                })
              }
              this.runTime = res1.runTime
              this.loading = false
              this.isDetail = true
            })
          }
          if (this.lineArr.length > 0) {
            this.marker.moveAlong(this.lineArr, 800)
          }
        }
      })
      if (this.mapData.type == 1 || this.mapData.type == 3) {
        this.loadingDrive = true
        driverHisDataList(this.searchFrom).then(res => {
          this.loadingDrive = false
          if (res.gpsInfos) {
            this.lineArr1 = res.gpsInfos
            var newList = []
            for (var i = 0; i < this.lineArr1.length; i++) {
              newList[i] = []
              newList[i][0] = this.lineArr1[i].encryptLongitude
              newList[i][1] = this.lineArr1[i].encryptDimension
            }
            this.dirverGPS = newList
            // console.log(this.dirverGPS,'this.dirverGPS')
            if (this.lineArr1.length > 0) {
              this.polylineFn1()
              this.marker1.moveAlong(this.dirverGPS, 800)
            }
          }
        })
      }
    },
    // 现车原车切换
    handleClick () {
      this.searchFn()
    },
    TimeCha (start, end) {
      const time = end - start
      const miao = time / 1000
      const fen = Math.floor(time / 1000 / 60)
      const shi = Math.floor(time / 1000 / 60 / 60)
      const tian = Math.floor(time / 1000 / 60 / 60 / 24)

      const chaShi = shi % 24
      const chaFen = fen % 60
      // const chaMiao = miao % 60 ${chaMiao}秒
      return `${tian}天${chaShi}小时${chaFen}分钟`
    },
    startAnimation () {
      if (!this.isStart) { this.isStart = true }
      if (this.isPlay) {
        this.marker.resumeMove()
      } else {
        this.marker.moveAlong(this.lineArr, 800)
      }
    },
    pauseAnimation () {
      this.marker.pauseMove()
      this.isPlay = true
    },
    addSudu () {
      // if (this.isStart) {
      this.isStart = true
      this.marker.moveAlong(this.lineArr, 1500)
      // }
    },
    reduceSudu () {
      this.isStart = true
      // if (this.isStart) {
      this.marker.moveAlong(this.lineArr, 500)
      // }
    },
    clearFn () {
      this.map.clearMap()
      this.searchFrom = { time: null }
      this.gpsInfos = []
    },
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
    },
    biaodianFn (dataArr) {
      this.infoWindow = new AMap.InfoWindow({
        anchor: 'top-left',
        offset: new AMap.Pixel(-10, -22) // 设置偏移量
      })
      let icon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(20, 20),
        // 图标的取图地址
        image: require('../../../../assets/dapingImg/dingwei.png'),
        // 图标所用图片大小
        imageSize: new AMap.Size(20, 20),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0)
      })
      var markerList = []
      dataArr.forEach(item => {
        markerList.push(
          new AMap.Marker({
            position: new AMap.LngLat(item.encryptLongitude, item.encryptDimension),
            // 添加 Icon 图标 URL
            icon: icon,
            data: item,
            offset: new AMap.Pixel(-10, -22) // 设置偏移量
          })
        )
      })
      this.map.add(markerList)
      console.log(markerList)
      for (var i = 0; i < markerList.length; i++) {
        let data = markerList[i].De.data
        console.log(data)
        let content =
            '<ul style="  margin:-10px 0 5px 0; padding:10px;">' +
            '<li style="line-height:26px; font-size:14px;color:#727272;margin-bottom:6px">' +
            '<span style="width:80px; display:inline-block;">当前位置：</span>' +
            data.addressGrid + '</li>' +
            '<li style="font-size:14px;color:#727272;;margin-bottom:6px">' +
            '<span style="width:80px; display:inline-block;" >上报时间：</span>' +
             data.gPSDate + '</li>' +
            '<li style="font-size:14px;color:#727272;;margin-bottom:6px">' +
            '<span style="width:80px; display:inline-block;" >行驶速度：</span>' +
             data.speed + 'KM/H</li>' +
            '<li style="font-size:14px;color:#727272;;margin-bottom:6px">' +
            '<span style="width:80px; display:inline-block;" >行驶方向：</span>' +
             this.fx(null, null, data.direction) + '</li>' +
            '</ul>'
        markerList[i].content = content
        markerList[i].on('click', this.markerClick)
      }
    },
    markerClick (e) {
      // 标注的点击事件
      this.infoWindow.setContent(e.target.content)
      this.infoWindow.open(this.map, e.target.getPosition())
    },
    polylineFn () {
      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(40, 45),
        // 图标的取图地址
        image: require('../../../../assets/dapingImg/装.png'),
        // 图标所用图片大小
        imageSize: new AMap.Size(40, 45),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0)
      })
      var startIcon1 = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(40, 45),
        // 图标的取图地址
        image: require('../../../../assets/dapingImg/卸.png'),
        // 图标所用图片大小
        imageSize: new AMap.Size(40, 45),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0)
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: [this.mapData.deliverLongitude, this.mapData.deliverLatitude], // this.lineArr[0]
        icon: startIcon,
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: [this.mapData.receivingLongitude, this.mapData.receivingLatitude], // this.lineArr[this.lineArr.length - 1]
        icon: startIcon1,
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lineArr[0],
        icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/cat.png',
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      // 绘制轨迹
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        showDir: true,
        strokeColor: '#28F', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      var passedPolyline = new AMap.Polyline({
        map: this.map,
        // path: lineArr,
        strokeColor: '#AF5', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.marker.on('click', this.showInfoM)
      this.map.setFitView()
    },
    showInfoM (e) {
      console.log(e)
      this.isDetail = true
      this.isveh = true
      this.activeName = 'gps'
    },
    polylineFn1 () {
      // console.log(this.dirverGPS,'this.dirverGPS')
      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(40, 45),
        // 图标的取图地址
        image: require('../../../../assets/dapingImg/始.png'),
        // 图标所用图片大小
        imageSize: new AMap.Size(40, 45),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0)
      })
      var startIcon1 = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(40, 45),
        // 图标的取图地址
        image: require('../../../../assets/dapingImg/终.png'),
        // 图标所用图片大小
        imageSize: new AMap.Size(40, 45),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0)
      })
      this.marker1 = new AMap.Marker({
        map: this.map,
        // position: this.dirverGPS[0],
        position: [this.mapData.deliverLongitude, this.mapData.deliverLatitude],
        icon: startIcon,
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker1 = new AMap.Marker({
        map: this.map,
        // position: this.dirverGPS[this.dirverGPS.length - 1],
        position: [this.mapData.receivingLongitude, this.mapData.receivingLatitude],
        icon: startIcon1,
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker1 = new AMap.Marker({
        map: this.map,
        position: this.dirverGPS[0],
        icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/siji.png',
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      // 绘制轨迹
      this.polyline1 = new AMap.Polyline({
        map: this.map,
        path: this.dirverGPS,
        showDir: true,
        strokeColor: '#589c0d', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      var passedPolyline = new AMap.Polyline({
        map: this.map,
        // path: lineArr,
        strokeColor: '#000', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      this.marker1.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.marker1.on('click', this.showInfoM1)
      this.map.setFitView()
    },
    showInfoM1 (e) {
      this.isDetail = true
      this.isveh = false
      this.activeName = 'siji'
    },
    closeFn () {
      this.isDetail = false
    },
    fx: function (row, column, cellValue) {
      // 北方向
      if (cellValue >= 0 && cellValue <= 22 || cellValue >= 338 && cellValue <= 360) {
        return '北'
      }
      // 东北方向
      if (cellValue >= 23 && cellValue <= 67) {
        return '东北'
      }
      // 东方向
      if (cellValue >= 68 && cellValue <= 112) {
        return '东'
      }
      // 东南方向
      if (cellValue >= 113 && cellValue <= 157) {
        return '东南'
      }
      // 南方向
      if (cellValue >= 158 && cellValue <= 202) {
        return '南'
      }
      // 西南方向
      if (cellValue >= 203 && cellValue <= 247) {
        return '西南'
      }
      // 西方向
      if (cellValue >= 248 && cellValue <= 292) {
        return '西'
      }
      // 西北方向
      if (cellValue >= 293 && cellValue <= 337) {
        return '西北'
      }
    },
    // 时间格式化
    dateFormat: function (cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
    }
  }
}
</script>

<style scoped lang='less'>
.zujian{
  height: calc(100vh - 40px);
  position: relative;
}
.manHeight{
  height: 400px;
  position: relative;
}
.manHeight{
  height: 400px;
  position: relative;
}
.fullHeight {
  height: calc(100vh - 100px); /* 全屏模式下的高度，减去标题栏等空间 */
  position: relative;
  width: 100%;
}
.changeCar{
  position: absolute;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 9999999;
  width:500px;
  span{
    margin: 0 10px;
    color: #409EFF;
  }
}
#map{
  width: 100%;
  height: 100%;
  position: relative;
}
.table{
  position:absolute;
  left: 0;
  bottom:0;
  z-index:9999;
  background: #fff;
  width: 100%;
}
 .close{
    height: 40px;
    position:absolute;
    top:0;
    right: 20px;
    display: flex;
    align-items: center;
    z-index: 99999;
  }
    /deep/.el-tabs__item{
    font-size: 12px;
  }
  /deep/.el-tabs__nav{
    padding-left: 10px;
  }
  /deep/.el-tab-pane{
    font-size: 12px;
  }
  /deep/.el-tabs__active-bar{
    left: 10px;
  }
  /deep/.el-tabs__header{
    margin: 0;
  }
  .detail {
  position: absolute;
  left: 0px;
  top: 0;
  background: #fff;
  width: 450px;
  border-radius: 0px 0px 0px 10px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.9);
  padding: 16px 0px;
  font-size: 12px;
  z-index: 999;
  .box1 {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    padding-left: 20px;
    padding-top: 10px;
    border-bottom: 1px solid #ddd;
    .item {
      width: 45%;
      margin-right: 10px;
      padding: 4px 0;
      display: flex;
    }
    .name {
      color: #0c46a2;
      flex-shrink: 0;
    }
    .item1 {
      width: 100%;
    }
  }
  .box2 {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    align-items: center;
    .item {
      margin: 0 10px;
    }
    .name {
      color: #0c46a2;
      flex-shrink: 0;
    }
    .btn1 {
      font-size: 34px;
    }
  }
}
</style>
